// The C4 icon, and the centre of its bounding box: the icon is drawn centred on the bomb's position
export const BOMB_PATH = 'M343 1428 c-46 -23 -49 -47 -43 -445 5 -371 5 -373 28 -395 l23 -23 655 0 656 0 19 24 c18 22 19 44 19 411 0 367 -1 389 -19 411 l-19 24 -649 2 c-445 1 -655 -1 -670 -9z m1235 -276 l-3 -187 -280 0 -280 0 -3 184 c-1 106 1 187 7 190 5 3 133 5 285 3 l276 -3 -2 -187z m-460 -294 l-3 -53 -38 -3 c-21 -2 -45 2 -53 9 -14 12 -20 80 -7 92 3 4 28 7 55 7 l49 0 -3 -52z m150 0 l-3 -53 -38 -3 c-21 -2 -45 2 -53 9 -14 12 -20 80 -7 92 3 4 28 7 55 7 l49 0 -3 -52z m150 0 l-3 -53 -38 -3 c-21 -2 -45 2 -53 9 -14 12 -20 80 -7 92 3 4 28 7 55 7 l49 0 -3 -52z m150 0 c-3 -50 -5 -53 -32 -56 -15 -2 -39 -1 -52 2 -21 6 -24 12 -24 50 0 23 3 46 7 49 3 4 28 7 55 7 l49 0 -3 -52z m-450 -156 l3 -53 -53 3 -53 3 -3 38 c-4 52 12 69 62 65 l41 -3 3 -53z m150 0 l3 -53 -53 3 -53 3 -3 38 c-4 52 12 69 62 65 l41 -3 3 -53z m150 0 l3 -53 -53 3 -53 3 -3 44 c-4 52 7 62 63 59 l40 -3 3 -53z m150 0 l3 -53 -53 3 -53 3 -3 44 c-4 52 7 62 63 59 l40 -3 3 -53z';
export const BOMB_CENTRE = [999, 1001];

// Who carries the bomb: the living T with C4 in their inventory (the frame has no carrier field)
export function bombCarrier(playerStates) {
  const carrier = Object.values(playerStates || {}).find((p) => p.side === 'T'
    && p.isAlive !== false && p.hp !== 0
    && p.inventory?.some((i) => i.weaponName === 'C4'));
  return carrier?.steamID ?? null;
}

export function getBombColor(bombState, bombPlantEvent, currentTick) {
  if (!bombPlantEvent) return '#ff6b6b';

  const plantTick = bombPlantEvent.tick || 0;
  const timeSincePlant = (currentTick - plantTick) / 64;

  if (timeSincePlant < 5) {
    return '#ff6b6b';
  } if (timeSincePlant < 35) {
    return '#ffa500';
  }
  return '#ff0000';
}

export function updateBomb(roundData, currentFrame, currentTick, getConvertedCords, getObjectOpacity, bombPlantEvent, bombEventCache) {
  if (!roundData || !roundData.frames || !roundData.frames[currentFrame]) {
    return null;
  }

  const frame = roundData.frames[currentFrame];

  if (!frame.bomb) {
    return null;
  }

  const { bomb } = frame;

  if (!frame.bombPlanted) {
    if (bomb.x !== undefined && bomb.y !== undefined) {
      const cords = getConvertedCords(bomb.x, bomb.y);
      if (!cords) return null;

      const opacity = getObjectOpacity ? getObjectOpacity(bomb.z || 0, 1.0) : 1.0;

      return {
        x: cords.x,
        y: cords.y,
        z: bomb.z || 0,
        color: '#ff6b6b',
        opacity,
        isPlanted: false,
        defuseProgress: 0,
      };
    }
    return null;
  }

  if (bomb.x !== undefined && bomb.y !== undefined) {
    const cords = getConvertedCords(bomb.x, bomb.y);
    if (!cords) return null;

    const opacity = getObjectOpacity ? getObjectOpacity(bomb.z || 0, 1.0) : 1.0;
    const color = getBombColor(null, bombPlantEvent, currentTick);

    let defuseProgress = 0;
    let isDefusing = false;

    if (bombEventCache) {
      const defuseStartEvents = bombEventCache.get('bomb_defuse_start') || [];
      const defuseStartEvent = defuseStartEvents
        .filter((event) => event.tick <= currentTick)
        .pop();

      if (defuseStartEvent) {
        const defuseEndEvents = [
          ...(bombEventCache.get('bomb_defused') || []),
          ...(bombEventCache.get('bomb_defuse_abort') || []),
        ];

        const defuseEndEvent = defuseEndEvents.find((event) => event.tick > defuseStartEvent.tick && event.tick <= currentTick);

        if (!defuseEndEvent) {
          isDefusing = true;
          const defusalTime = defuseStartEvent.hasKit ? (5 * 64) : (10 * 64);
          const elapsed = currentTick - defuseStartEvent.tick;
          defuseProgress = Math.max(0, Math.min(1, elapsed / defusalTime));
        }
      }
    }

    return {
      x: cords.x,
      y: cords.y,
      z: bomb.z || 0,
      color,
      opacity,
      isPlanted: true,
      bombsite: frame.bombsite || null,
      isDefusing,
      defuseProgress,
    };
  }

  return null;
}

export function findBombPlantEvent(roundData, currentTick) {
  if (!roundData || !roundData.bombEvents) return null;

  let plantEvent = null;

  roundData.bombEvents.forEach((event) => {
    // Check for both 'bomb_planted' and legacy 'plant' event names
    if ((event.event === 'bomb_planted' || event.event === 'plant') && event.tick <= currentTick) {
      if (!plantEvent || event.tick > plantEvent.tick) {
        plantEvent = event;
      }
    }
  });

  return plantEvent;
}
